import React from 'react';
import { findDomNode } from 'react-dom';
import request from 'superagent';
import Backdrop from './components/Backdrop';
import { NotificationManager } from 'react-notifications';
export let RequestConfig = {

}

//底层提供的JSON对时间的支持不太好，所以要用自定义的
export function parseJSON(code) {
  if (!code) return;
  let obj = null;
  eval("obj=" + code + ";");
  return obj;
}

export function stringifyJSON(obj) {
  return JSON.stringify(obj);
}

export function redirect(url) {
  let ts = new Date().getTime();
  url = url.indexOf('?') > -1 ? `${url}&ts=${ts}` : `${url}?ts=${ts}`;
  window.location.href = url;
}

// Private array of chars to use
const uuid_CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');

export function uuid(len, radix) { //大多数情况下不需要传递参数直接使用uuid得到完整的guid
  let chars = uuid_CHARS, uuid = [], i;
  radix = radix || chars.length;

  if (len) {
      // Compact form
      for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
  } else {
      // rfc4122, version 4 form
      var r;

      // rfc4122 requires these characters
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
      uuid[14] = '4';

      // Fill in random data.  At i==19 set the high bits of clock sequence as
      // per rfc4122, sec. 4.1.5
      for (i = 0; i < 36; i++) {
          if (!uuid[i]) {
              r = 0 | Math.random() * 16;
              uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
          }
      }
  }

  return uuid.join('');
}

uuid.slim = (v) => {
  if (!v) return '';
  return v.replace(/[\{\}-]/g, '');
}

let currentFeature = null;

export function Request(p) { //url,data,timeout,type,event:{dataFilter,before,success,complete,error}
  initRequest(p);
  if (!p.type) p.type = "POST";
  if (p.before) p.before(p);

  let headers = p.headers || {};
  if (!headers['Content-Type']) {
    if (!p.blob) //blob不要设置content-type ，superagent框架会自动设置
      headers['Content-Type'] = 'application/json';

    if (p.blob) {
      headers['directoryId'] = p.directoryId;
      if (p.size) //如果指定了文件大小，那么发送到服务器，以便效验
        headers['fileSize'] = p.size;
    }
  }
  let body = p.blob ? (p.data || null) : (p.data ? JSON.stringify(p.data) : null);

  let feature = p.type == "POST" ? request.post(p.url) : request.get(p.url);
  currentFeature = feature;
  //feature.withCredentials(); //可以激活发送原始cookie的能力，不过只有在Access-Control-Allow-Origin不是一个通配符(*)，并且Access-Control-Allow-Credentials为’true’的情况下才行
  feature.set(headers);
  if (p.blob) {
    feature.timeout({
      response: 600000000,  // Wait 1000 seconds for the server to start sending,
      deadline: 600000000, // but allow 3000 seconds for the file to finish loading.
    }).on('progress', e => {
      if (p.progress) p.progress(e);
    })
    feature.field("file", body);
  }
  else {
    feature.timeout({
      response: 60000,  // Wait 10 seconds for the server to start sending,
      deadline: 60000, // but allow 30 seconds for the file to finish loading.
    });
    feature.send(body);
  }

  if (p.await) {
    return new Promise((resolve, reject) => {
      feature.then((response) => {
        processResponse(response);
        currentFeature = null;
        let result = parseJSON(response.text);
        resolve(result);
      }, (e) => {
        currentFeature = null;
        let error = getErrorMessage(e);
        reject(error);
      });
    });
  }

  const processError = (e) => {
    if (p.complete)
      p.complete();
    if (p.error)
      p.error(e);
  }

  return feature.then(response => {
    processResponse(response);
    currentFeature = null;
    if (p.complete)
      p.complete();

    let result = parseJSON(response.text);

    if (p.dataFilter)
      result = p.dataFilter(result);

    if (p.success)
      p.success(result);
  }, e => {
    currentFeature = null;
    processError(e);
  });

}

Request.mute = Request.background = (arg) => {
  Request({ //静默调用
    before: () => {
    },
    success: (r) => {
    },
    complete: () => {
    },
    error: (msg) => {
      Notification.error(msg);
    },
    ...arg
  });
}

let _requestEvents = {};

Request.on = (name, func) => {
  let l = _requestEvents[name];
  if (!l) l = _requestEvents[name] = [];
  l.push(func);
}


function processResponse(response) {
  let l = _requestEvents["process"];//process是处理请求的最开始的事件
  if (l) {
    l.forEach((func) => {
      func(response);
    });
  }
}

Request.call = function (p) {
  return Request({
    ...p,
    await: true
  });
}

Request.abort = function () {
  if (currentFeature) {
    currentFeature.abort(); //取消后，文件已传部分还是会被保存，所以需要指定fileSie头，让服务端删除冗余文件
    currentFeature = null;
    return true;
  }
  return false;
}


function initRequest(p) {
  if (RequestConfig.init) {
    RequestConfig.init(p);
  }
  if (!p.url.startsWith("http:") && !p.url.startsWith("https:")) {
    p.url = RequestConfig.domain + p.url;
  }

  if (p.await) return;
  if (!p.before) p.before = RequestConfig.before;
  if (!p.complete) p.complete = RequestConfig.complete;
  if (!p.error) {
    p.error = function (e) {
      let msg = getErrorMessage(e, p.url);
      if (RequestErrorIoc(msg, p) === false) return; //如果依赖注入拦截了错误，那么后续不再处理
      RequestConfig.error(msg);
    };
  } else {
    let _error = p.error;
    p.error = function (e) {
      let msg = getErrorMessage(e, p.url);
      if (RequestErrorIoc(msg, p) === false) return; //如果依赖注入拦截了错误，那么后续不再处理
      _error(msg);
    };
  }
}

function RequestErrorIoc(msg, p) {
  let ioc = RequestConfig.ioc;
  if (!ioc || !ioc.error) return;
  return ioc.error(msg, p);
}


function getErrorMessage(e, url) {
  if (e.response && e.response.text) return e.response.text;  //ff这样获取错误
  let msg = e.message;
  if ((msg.indexOf(" timeout ") > -1) || (msg.indexOf("Timeout ") > -1)) msg = `${url || ''}请求超时`;
  if (msg.indexOf("Abort") > -1) msg = "请求已取消";
  return msg;
}


export function Upload(p) {
  let args = p.data || {};
  if (args.file) {
    p.data = args.file;
    p.size = args.file.size;
  }
  else {
    p.data = args.blob;
    //formData.append("file", args.blob, args.fileName);
  }

  p.blob = true;
  p.url = RequestConfig.uploadUrl;
  p.directoryId = args.directoryId;
  return Request(p);
}

export const PromiseUtil = {
  queue: async (promises) => {
    return await promises.reduce((prev, next) => {
      return prev.then(arg => {
        return next;
      });
    });
  }
}

export class Storage {

  static get(name, defaultValue) {
    let key = Storage.getKey(name);
    let code = localStorage.getItem(key);
    return code ? JSON.parse(code) : defaultValue;
  }

  static set(name, value) {
    let key = Storage.getKey(name);
    let code = JSON.stringify(value);
    localStorage.setItem(key, code);
  }

  static remove(name) {
    let key = Storage.getKey(name);
    localStorage.removeItem(key);
  }

  static removes(func) {//要删除的返回true
    Storage.filter((key) => {
      return func(key);
    }).forEach((key) => {
      localStorage.removeItem(key);
    });
  }

  static getKey(name) {
    return `${name}-v${Storage.version || '1.0'}`;
  }

  static filter(func) { //保留的返回true
    let key;
    let l = [];
    for (let i = 0; key = localStorage.key(i); i++) {
      if (func(key)) {
        l.push(key);
      }
    }
    return l;
  }
}

export let Notification = {
  error: (msg) => {
    NotificationManager.error(getNotificationMessage(msg));
  },
  warning: (msg) => {
    NotificationManager.warning(getNotificationMessage(msg));
  },
  success: (msg) => {
    NotificationManager.success(getNotificationMessage(msg));
  },
}

function getNotificationMessage(msg) {
  var type = Util.type(msg);
  if (type == "string") return msg;
  if (type == "array") return <div>{msg.map((m, i) => <p key={i} className="c-notification">{m}</p>)}</div>
  if (type == "object") {
    if (msg.stack) return msg.stack;
    if (msg.toString) return msg.toString();
    return JSON.stringify(msg);
  }
}
function deepEmpty(v) {
  var ty = Util.type(v);
  if (ty == "array") {
    if (v.length == 0) return true;
    for (var i = 0; i < v.length; i++) {
      let t = v[i];
      var b = deepEmpty(t);
      if (!b) return false;
    }
    return true;
  }

  if (ty == "object") {
    if (Util.dtoEmpty(v)) return true;
    for (var e in v) {
      var t = v[e];
      if (!deepEmpty(t)) return false;
    }
    return true;
  }

  if (ty == "function" || ty == "null") return true;
  return Util.empty(v);
}

function equals(o0, o1, arg) {
  if (!arg) arg = {};
  let type = Util.type(o0);
  if (type === "object") {
    return objectEquals(o0, o1, arg);
  }

  if (type === "array") {
    return arrayEquals(o0, o1, arg);
  }

  if (arg.valueIgnoreCase) {
    return o0.toLowerCase() === o1.toLowerCase();
  }

  if (arg.strong) { //强类型对比
    return o0 === o1;
  }

  //默认不是强类型
  return o0 == o1;  //这里不识别类型，也就是说1是等于'1'的
}

function objectEquals(o0, o1, arg) {
  if ((o0 && !o1) || (!o0 && o1)) return false;
  return objectEqualsAB(o0, o1, arg) && objectEqualsAB(o1, o0, arg);
}

function objectEqualsAB(o0, o1, arg) {
  for (var e in o0) {
    let left, right;
    if (arg.propertyIgnoreCase) {  //忽略属性名大小写比较
      left = objGet(o0, e);
      right = objGet(o1, e);
    }
    else {
      left = o0[e];
      right = o1[e];
    }
    if (!equals(left, right, arg)) return false;
  }
  return true;
}

function arrayEquals(o0, o1, arg) {
  if ((o0 && !o1) || (!o0 && o1)) return false;
  if (o0.length !== o1.length) return false;
  for (var i = 0; i < o0.length; i++) {
    if (!equals(o0[i], o1[i], arg)) return false;
  }
  return true;
}

export function objGet(o, p) {  //不区分大小写的获取对象属性
  p = p.toLowerCase();
  for (var e in o) {
    if (o.hasOwnProperty(e) && e.toLowerCase() === p) {
      return o[e];
    }
  }
}

export function objSet(o, p, v) {  //不区分大小写的设置对象属性
  p = p.toLowerCase();
  for (var e in o) {
    if (o.hasOwnProperty(e) && e.toLowerCase() === p) {
      return o[e] = v;
    }
  }
}

var _currentId = 0;
export let Util = {
  getId: () => {
    return ++_currentId;
  },
  invalid: (v) => { //无效的数据
    return v === undefined || v === null || (typeof v === 'number' && isNaN(v));
  },
  empty: (v) => {
    if (Util.invalid(v) || v === "") return true;
    if (Util.dtoEmpty(v)) return true;
    let code = JSON.stringify(v);
    if (code === '{}' || code === '[]') return true;
    return false;
  },
  dtoEmpty: (v) => {
    if (Util.invalid(v)) return true;
    return v.__empty;
  },
  deepEmpty,
  equals,
  arrayEquals: (left, right, arg) => {
    arg = arg || {};
    let { order, func } = arg;
    if (!func) func = function (v0, v1) { return v0 == v1; }
    if (left.length !== right.length) return;
    if (order) {
      for (var i = 0; i < left.length; i++) {
        if (!func(left[i], right[i])) return false;
      }
    } else {
      for (var i = 0; i < left.length; i++) {
        if (!Util.contains(right, (t) => func(t, left[i]))) return false;
      }
    }
    return true;
  },
  type: (o) => {
    let ty = typeof o;
    if (ty == 'object') {
      if (o == null) return "null";
      if (o.constructor == Array) return "array";
      if (o.constructor == Date) return "date";
      //if (isEvent(o)) return "event";
      if (o.constructor == Blob) return "blob";
      if (o.type && o.type.name) return o.type.name;
    }
    return ty;
  },
  insert: function (l, i, t) {
    l.splice(i, 0, t);
  },
  first: (l, f) => {
    if (f) {
      for (var i = 0; i < l.length; i++) {
        var o = l[i];
        if (f(o, i)) {
          return o;
        }
      }
      return null;
    }
    return l.length > 0 ? l[0] : null;
  },
  contains: (l, f) => {
    if (Util.type(f) != 'function') { //传递的值，那么就直接对比
      var v = f;
      f = function (v1, i) {
        return v == v1;
      };
    }
    return !Util.empty(Util.first(l, f));
  },
  diff: function (arr1, arr2, f) { //取交集
    let diff = [];
    let tmp = [...arr2];
    let indexOf = (l, v) => {
      return Util.indexOf(l, (t) => {
        return f(v, t);
      });
    };

    arr1.forEach(function (val1, i) {
      if (indexOf(arr2, val1) < 0) {
        diff.push(val1);
      } else {
        tmp.splice(indexOf(tmp, val1), 1);
      }
    });

    return diff.concat(tmp);
  },
  distinct: function (s, f) { //返回非重复序列,f是比较函数，相等返回true
    if (!f) f = function (v0, v1) { return v0 == v1; }
    let l = [];
    s.forEach((v0, i) => {
      let r = Util.first(l, (v1, j) => f(v0, v1));
      if (!r) l.push(v0);
    });
    return l;
  },
  indexOf: (l, f) => {
    for (let i = 0; i < l.length; i++) {
      let o = l[i];
      if (f(o, i)) {
        return i;
      }
    }
    return -1;
  },
  removeAt: (l, p) => {
    var le = l.length;
    if (p < 0 || p >= le) return;
    for (var i = p; i < le - 1; i++) l[i] = l[i + 1];
    return l.pop();
  },
  remove: (l, f) => {
    let index = Util.indexOf(l, f);
    Util.removeAt(l, index);
  },
  min: (l, f) => {
    if (!l || l.length == 0) return null;
    var min, c;
    for (var i = 0; i < l.length; i++) {
      var o = l[i], v = f(o);
      if (i == 0) {
        c = v;
        min = o;
      } else {
        if (v < c) {
          c = v;
          min = o;
        }
      }
    }
    return min;
  },
  max: (l, f) => {
    if (!l || l.length == 0) return null;
    var max, c;
    if (!f) f = (t) => t;
    for (let i = 0; i < l.length; i++) {
      let o = l[i], v = f(o);
      if (i == 0) {
        c = v;
        max = o;
      } else {
        if (v > c) {
          c = v;
          max = o;
        }
      }
    }
    return max;
  },
  each(l, m) {
    var v;
    for (var i = 0; i < l.length; i++) {
      var c = l[i];
      if (m.apply(c, [i, c]) == false) break; //显示传递false,代表中断循环
    }
  },
  order(l, func, t) { //type:asc desc
    if (!t) t = "asc";
    var m = {};
    var ef = t === "asc" ? function (a, b) { return a < b; } : function (a, b) { return a > b; };
    for (var i = 0; i < l.length; i++) {
      for (var k = 0; k < l.length; k++) {
        if (ef(func(l[i]), func(l[k]))) {
          m = l[k];
          l[k] = l[i];
          l[i] = m;
        }
      }
    }
    return l;
  },
  select(l, f) { //与c#用法一样
    var r = [];
    Util.each(l, function () {
      var t = f(this);
      r.push(t);
    });
    return r;
  },
  where: (l, f) => { //与c#用法一样
    var r = [];
    Util.each(l, function () {
      var t = this;
      if (f(t)) r.push(t);
    });
    return r;
  },
  clone: (o) => {
    let code = stringifyJSON(o);
    return parseJSON(code);
    // var oc = o.constructor == Object ? new o.constructor() : new o.constructor(o.valueOf());
    // for (var key in o) {
    //     var ocv = oc[key], tcv = o[key];
    //     if (ocv != tcv) {
    //         oc[key] = typeof (tcv) == 'object' ? Util.clone(tcv) : tcv;
    //     }
    // }
    // oc.toString = o.toString;
    // oc.valueOf = o.valueOf;
    // return oc;
  }, getQuarter(v) {
    let month = v || new Date().getMonth() + 1;
    var quarter = month / 3;
    if (month % 3 > 0) quarter++;
    return parseInt(quarter);
  },
  padLeft(v, length, sign) {
    var s = v + '';
    return new Array(length - s.length + 1).join(sign, '') + s;
  },
  padRight(v, length, sign) {
    var s = v + '';
    return s + new Array(length - s.length + 1).join(sign, '');
  },
  addDays(v, days) {
    let temp = new Date(v);
    temp.setDate(temp.getDate() + days);
    return temp;
  },
  sameDay(t0,t1){
    return t0.getFullYear() == t1.getFullYear() 
            && t0.getMonth() == t1.getMonth() 
            && t0.getDate() == t1.getDate();
  },
  differenceDays(v, v1) {
    return Math.floor(Math.abs(Date.parse(v) - Date.parse(v1)) / (24 * 3600 * 1000));
  },
  // isSelf: function (v) {
  //   return Principal.current().id == v;
  // },
  trim: (str) => {
    return str.replace(/(^\s*)|(\s*$)/g, "")
  },
  isChinaMobile: (tel) => {
    if (Util.empty(tel)) return false;

    let reg = /^0?1[3|4|5|6|7|8|9][0-9]\d{8}$/;
    return reg.test(tel);
  },
  groupBy: (l, f) => {
    const gs = {};
    l.forEach(function (o) {
      const g = JSON.stringify(f(o));
      gs[g] = gs[g] || [];
      gs[g].push(o);
    });
    return Object.keys(gs).map(function (g) {
      return gs[g];
    });
  },
  delHtmlTag: (v) => {
    return v.replace(/<[^>]+>/g, "");
  }
}

export function childrenText(children) {
  if (Util.invalid(children)) return '';
  return React.Children.map(children, function (child) {
    if (Util.type(child) === "string") return child;
    let c = child.props ? (child.props.children || child.children) : child.children;
    if (c) return childrenText(c);
    return '';
    // let obj = findDomNode(child);  不知道为什么，报错
    // return obj.innerText || obj.textContent;
  }).join('');
}

export function createIcon(icon, className, p) {
  if (!icon) return null;
  if (typeof icon == "string") {
    icon = <i className={`zmdi zmdi-${icon} ${className}`} {...p} />;
  } else {
    const Icon = icon;
    icon = <Icon className={`zmdi ${className}`} {...p} />
  }
  return icon;
}




export function twoDecimal(x) {
  try {
    let x1 = parseFloat(x);
    if (isNaN(x1)) {
      return x;
    }
    let f_x = Math.round(x * 100) / 100;
    let s_x = f_x.toString();
    let pos_decimal = s_x.indexOf('.');
    if (pos_decimal < 0) {
      pos_decimal = s_x.length;
      s_x += '.';
    }
    while (s_x.length <= pos_decimal + 2) {
      s_x += '0';
    }
    return s_x;
  } catch (e) {
    return '0.00';
  }
}

export function threePosition(n){
  if(Util.invalid(n)) return;
  let b=parseInt(n).toString();
  let len=b.length;
  if(len<=3){return b;}
  let r=len%3;
  return r>0?b.slice(0,r)+","+b.slice(r,len).match(/\d{3}/g).join(","):b.slice(r,len).match(/\d{3}/g).join(",");
}

export function getImageSize(src, cb) {
  var g = new Image();
  g.src = src;
  if (g.complete) {
    cb({ width: g.width, height: g.height });
  } else {
    Backdrop.current.show();
    g.onload = function () {
      Backdrop.current.hide();
      cb({ width: g.width, height: g.height });
    }
  }
}


function getHumanizeHour(hour) {
  return hour >= 0 && hour <= 12 ? "上午" : "下午";
}


function yesterday() {
  var t = new Date();
  t.setTime(t.getTime() - 24 * 60 * 60 * 1000);
  return t;
}

export function humanize(value) {
  if (!value) return '';
  let now = new Date();
  let yest = yesterday();
  let hour = value.getHours();

  let tip = hour >= 0 && hour <= 12 ? "上午" : "下午";
  let HH = Util.padLeft(value.getHours(), 2, "0");
  let mm = Util.padLeft(value.getMinutes(), 2, "0");
  if (value.getFullYear() == now.getFullYear() && value.getMonth() == now.getMonth() && value.getDate() == now.getDate()) return `今天 ${tip}${HH}:${mm}`;
  if (value.getFullYear == yest.getFullYear() && value.getMonth() == yest.getMonth() && value.getDate() == yest.getDate()) return `昨天 ${tip}${HH}:${mm}`;

  let MM = Util.padLeft(value.getMonth() + 1, 2, "0");
  let dd = Util.padLeft(value.getDate(), 2, "0");
  return `${MM}月${dd}日 ${tip}${HH}:${mm}`;
}

export function humanizeYMD(value) {
  if (!value) return '';
  let now = new Date();
  let yest = yesterday();

  if (value.getFullYear() == now.getFullYear() && value.getMonth() == now.getMonth() && value.getDate() == now.getDate()) return `今天`;
  if (value.getFullYear == yest.getFullYear() && value.getMonth() == yest.getMonth() && value.getDate() == yest.getDate()) return `昨天`;

  let MM = Util.padLeft(value.getMonth() + 1, 2, "0");
  let dd = Util.padLeft(value.getDate(), 2, "0");
  return `${MM}月${dd}日`;
}

export function thousand(value) {
  return (value + '').replace(new RegExp('(\\d)(?=(\\d{3})+$)', 'ig'), "$1,");
}

export const TimeUtil = {
  humanize: humanize,
  format: (value, c) => {
    if (!value) return '';
    if (!c) c = {};

    let separator = c.separator || '/';

    let YYYY = c.YYYY === false ? null : value.getFullYear();
    let MM = c.MM === false ? null : Util.padLeft(value.getMonth() + 1, 2, "0");
    let dd = c.dd === false ? null : Util.padLeft(value.getDate(), 2, "0");

    let HH = c.HH === false ? null : Util.padLeft(value.getHours(), 2, "0");
    let mm = c.mm === false ? null : Util.padLeft(value.getMinutes(), 2, "0");
    let ss = c.ss === false ? null : Util.padLeft(value.getSeconds(), 2, "0");

    let left = [];
    if (YYYY) left.push(YYYY);
    if (MM) left.push(MM);
    if (dd) left.push(dd);
    left = left.join(separator);

    let right = [];
    if (HH) right.push(HH);
    if (mm) right.push(mm);
    if (ss) right.push(ss);
    right = right.join(':');

    if (left == "") return right;
    if (right == "") return left;

    return [left, right].join(' ');
  },
  full: (value, separator) => {
    return TimeUtil.format(value, { separator });
  },
  longMinute: (value, separator) => {  //转换成长时间格式的分钟
    return TimeUtil.format(value, { separator, ss: false });
  },
  during: (value) => { // 将秒数格式化为00:00:00的格式
    let hour = Math.floor(value / 3600);
    let HH = Util.padLeft(hour, 2, "0");

    let minute = Math.floor(value % 3600 / 60);
    let mm = Util.padLeft(minute, 2, "0");

    let second = Math.floor((value - 60 * minute) % 60);
    let ss = Util.padLeft(second, 2, "0");

    return `${HH}:${mm}:${ss}`;
  }
}

export let runtime = {};

function initRuntime() {
  const params = new URLSearchParams(window.location.search);
  runtime.mobile = params.has("device-mobile") || /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);
  runtime.pc = !runtime.mobile;
}

initRuntime();


let _scrollRecords = {};
let _scrollLoadTimes = 0;
let _scrollPosition = { left: 0, right: 0 };

function onHostScrollMoved(e) {
  let host = e.target;
  _scrollPosition = { top: host.scrollTop, left: host.scrollLeft };
}

export let Scroller = {
  save: (keepId) => {
    if (!keepId) return;
    _scrollRecords[keepId] = Scroller.get();
  },
  load: (keepId) => {
    if (!keepId) return;
    let data = _scrollRecords[keepId];
    if (!data) return false;

    let host = document.getElementById(Scroller.host);
    if (host.scrollHeight == host.offsetHeight) return; //如果滚动条高度等于滚动条所在宿主的高度，那么滚动条是没有可移动空间的，也就是没有滚动条
    host.scrollTo(data.left, data.top);
    _scrollLoadTimes++;

    //效验是否改变
    let pos = Scroller.get();
    if ((pos.top == data.top && pos.left == data.left)  //已设置成功
      || (pos.top > 0 || pos.left > 0)  //用户在滚动条加载期间动了屏幕
      || (_scrollLoadTimes >= 10)) //超过尝试加载的最大次数
    {
      //满足了3个条件之一，那么删除数据，不再加载
      delete _scrollRecords[keepId];
      _scrollLoadTimes = 0;
    } else {
      setTimeout(() => {
        Scroller.load(keepId);
      }, 100);
    }

  },
  remove: (keepId) => {
    delete _scrollRecords[keepId];
  },
  clear: () => {
    _scrollRecords = {};
  },
  get: () => {
    return { ..._scrollPosition };
    // var host = document.getElementById(Scroller.host);
    // return { top: host.scrollTop, left: host.scrollLeft };
  },
  host: "app-main-content",  //在ios下，把body的高度设置了100%，这时候body不会再产生滚动条，而是由#app-main-content-wrapper产生滚动条，另外，安卓下不论什么情况都是#app-main-content-wrapper产生滚动条
  init: () => {
    let host = document.getElementById(Scroller.host);
    if (!host) return false;
    if (host.__scrollerInited) return true;
    host.__scrollerInited = true;
    host.addEventListener("scroll", onHostScrollMoved);
    return true;
  },
  dispose: () => {
    let host = document.getElementById(Scroller.host);
    if (!host || !host.__scrollerInited) return;
    host.__scrollerInited = false;
    host.removeEventListener("scroll", onHostScrollMoved);
  }
}

let _states = {};
export let StateProvider = {
  save: (keepId, state) => {
    if (!keepId || !state) return;
    _states[keepId] = state;
  },
  load: (keepId) => {
    if (!keepId) return;
    return _states[keepId];
  },
  remove: (keepId) => {
    delete _states[keepId];
  },
  contains: (keepId) => {
    return _states[keepId];
  },
  clear: () => {
    _states = {};
  }
}

let _proxies = {};
export let ProxyProvider = {
  set: (keepId, current) => {
    if (!keepId || !current) return;

    let prev = _proxies[keepId];
    if (prev) {
      let refs = prev.ref();
      current.ref({ ...refs });
    }

    _proxies[keepId] = current;
  },
  get: (keepId) => {
    if (!keepId) return;
    return _proxies[keepId];
  },
  remove: (keepId) => {
    delete _proxies[keepId];
  },
  clear: () => {
    _proxies = {};
  }
}


let _bindActivateds = {};
export let BAProvider = {
  getOrCreate: (keepId) => {
    if (!keepId) return;
    let l = _bindActivateds[keepId];
    if (!l) {
      l = _bindActivateds[keepId] = [];
    }
    return l;
  },
  get: (keepId) => {
    if (!keepId) return;
    return _bindActivateds[keepId];
  },
  remove: (keepId) => {
    delete _bindActivateds[keepId];
  },
  clear: () => {
    _bindActivateds = {};
  }
}


export function Config(props) {

  this.set = (props) => {
    for (var e in props) {
      this[e] = props[e];
    }
  }

  if (props)
    this.set(props);

}

export function formatSeconds(value) {
  if (Util.invalid(value)) value = 0;
  let secondTime = parseInt(value);// 秒
  let minuteTime = 0;// 分
  let hourTime = 0;// 小时
  if (secondTime > 60) {//如果秒数大于60，将秒数转换成整数
    //获取分钟，除以60取整数，得到整数分钟
    minuteTime = parseInt(secondTime / 60);
    //获取秒数，秒数取佘，得到整数秒数
    secondTime = parseInt(secondTime % 60);
    //如果分钟大于60，将分钟转换成小时
    if (minuteTime > 60) {
      //获取小时，获取分钟除以60，得到整数小时
      hourTime = parseInt(minuteTime / 60);
      //获取小时后取佘的分，获取分钟除以60取佘的分
      minuteTime = parseInt(minuteTime % 60);
    }
  }
  let result = parseInt(secondTime) + "秒";

  if (minuteTime > 0) {
    result = parseInt(minuteTime) + "分" + result;
  }
  if (hourTime > 0) {
    result = parseInt(hourTime) + "小时" + result;
  }
  return result;
}


export const HtmlUtil = {
  clear: (code) => {
    return code.replace(/<\/?.+?\/?>/g, '');
  }
}

export function toByteSize(value) {
  if (value === 0) return '0 B';
  let size = "";
  if (value < 0.1 * 1024) {                            //小于0.1KB，则转化成B
    size = value.toFixed(2) + "B"
  } else if (value < 0.1 * 1024 * 1024) {            //小于0.1MB，则转化成KB
    size = (value / 1024).toFixed(2) + "K"
  } else if (value < 0.1 * 1024 * 1024 * 1024) {        //小于0.1GB，则转化成MB
    size = (value / (1024 * 1024)).toFixed(2) + "M"
  } else {                                            //其他转化成GB
    size = (value / (1024 * 1024 * 1024)).toFixed(2) + "G"
  }

  let sizeStr = size + "";                        //转成字符串
  let index = sizeStr.indexOf(".");                    //获取小数点处的索引
  let dou = sizeStr.substr(index + 1, 2)            //获取小数点后两位的值
  if (dou == "00") {                                //判断后两位是否为00，如果是则删除00                
    return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
  }
  return size;
}


// export function toByteSize(bytes) {
//   if (bytes === 0) return '0 B';
//   var k = 1000, // or 1024
//     sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
//     i = Math.floor(Math.log(bytes) / Math.log(k));
//   return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
// }

export const Guid = {
  empty: "00000000-0000-0000-0000-000000000000"
}